import { cn } from "@/lib/utils";
import { ProductImage } from "@/utils/elevate/getImageInfoFromProduct";
import { ComponentProps } from "react";
import ProductCardImageCarousel from "./ProductCardImageCarousel";
import ProductCardImageFlat from "./ProductCardImageFlat";

export default function ProductCardImage({
  images,
  className,
  children,
  ...props
}: { images: ProductImage[] } & ComponentProps<"div">) {
  if (!images.length) return null;

  const [primaryImage, secondaryImage] = images;

  return (
    <div
      className={cn("aspect-portrait group/product-image relative", className)}
      {...props}
    >
      <ProductCardImageCarousel
        images={images}
        className="[@media(hover:hover)_and_(pointer:fine)]:hidden"
      />
      <ProductCardImageFlat
        src={primaryImage.src}
        alt={primaryImage.alt}
        width={400}
        height={500}
        hoverSrc={secondaryImage?.src}
        className="hidden [@media(hover:hover)_and_(pointer:fine)]:block"
      />
      {children}
    </div>
  );
}
